enum LocalStorage {
  TOKEN = "token",
  CURRENT_DC = "currentDc",
  SHOW_GENERATE_TRIP_ALERT = "showGenerateTripAlert",
  SHOW_SCHEDULE_APPROVAL_ALERT = "showScheduleApprovalAlert",
  PRODUCTION_DEPOT="productionDepot"
}

export const getLocalStorage = (key: string) =>
  JSON.parse(localStorage.getItem(key))
export const setLocalStorage = (key: string, value: any) =>
  localStorage.setItem(key, JSON.stringify(value))
export default LocalStorage
